import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Barcode from 'react-barcode';
import BotMessage from './BotMessage'
import UserMessage from './UserMessage'
import queryString from 'query-string';
import axios from 'axios';
import {saveMessage, chatbotLogin, saveTime} from '../../../_actions/chatbot_actions';
import {saveApplyCancelList, saveApplyList} from '../../../_actions/list_actions';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import book_see_chat_7 from '../img/JungRakCharacter/07.png';
import '../css/chat.css';
import '../css/reset.css';
import {ReadOutlined,
  UnorderedListOutlined, SyncOutlined, DownSquareTwoTone,AppstoreTwoTone,FireOutlined,NotificationOutlined,ManOutlined,WomanOutlined, QuestionCircleOutlined,EditOutlined,PushpinOutlined, BarChartOutlined,EllipsisOutlined, AlertTwoTone , DashboardTwoTone, ClockCircleOutlined, SmileOutlined, SettingOutlined, BookOutlined, ThunderboltOutlined  } from '@ant-design/icons';
import {  Collapse , Col,Carousel, Card , Popover, Row, Image, Avatar, Modal, message, Popconfirm, Statistic, Descriptions, List, notification , Button, Spin, Menu, Drawer, Dropdown, Space, Tooltip, AutoComplete, Badge   } from 'antd';
import { type } from '@testing-library/user-event/dist/type';
const { Panel } = Collapse;

export default function Chatbot() {



  const contentStyle = {
    margin: 0,
    height: '150px',
    color: '#fff',
    lineHeight: '150px',
    textAlign: 'center',
  };

  
  const { Meta } = Card;
  const style = {
    background: '#fff',
    padding: '8px 0',
  };

  const { Countdown } = Statistic;

  const libraryList = 
  [{value:'MA',label:'중랑'}, {value:'MB',label:'면목'},  {value:'ME',label:'양원'},   {value:'MF',label:'상봉'}, {value:'MC',label:'중화'}, 
  {value:'MD',label:'중랑숲'}, {value:'LF',label:'면목2동'}, 
  {value:'LG',label:'면목3,8동'}, {value:'LH',label:'면목4동'}, {value:'LI',label:'면목5동'}, 
  {value:'LJ',label:'면목7동'}, {value:'LK',label:'상봉1동'},{value:'LM',label:'중화1동'}, 
  {value:'LN',label:'중화2동'}, {value:'LO', label:'묵1동'}, {value:'LA',label:'묵2동'}, {value:'LB',label:'망우본동'},
  {value:'LC',label:'망우3동'}, {value:'LD', label:'신내1동'}, {value:'LE',label:'신내2동'}, {value:'LP',label:'나무그늘'},
  {value:'LQ',label:'데시앙'}, {value:'LR', label:'장미'}, {value:'LS',label:'겸재'}, {value:'LW',label:'행복터'},
  {value:'LX',label:'장미마을소망'}, {value:'LT', label:'스마트도서관'}, {value:'LU',label:'송곡여고'}
];
  
  let library           ='통합';
  let libraryManageCode = 'ALL';
  const [spinning, setSpinning] = React.useState(false);
  const [Expire, setExpire] = useState(0);
  const [LoginPopup, setLoginPopup] = useState(false);
  const [AgentResponse, setAgentResponse] = useState([]);
  const [AvatarSetting, setAvatarSetting] = useState(false);
  const [IntentName, setIntentName] = useState('');
  const [UserInfo, setUserInfo] = useState(false);
  const [BarcodeFrame, setBarcodeFrame] = useState('');
  const [UserName, setUserName] = useState('');
  const [UserLibName, setUserLibName] = useState('');
  const [UserLoanCnt, setUserLoanCnt] = useState('');
  const [UserMemberClassDesc, setUserMemberClassDesc] = useState('');
  const [UserLoanStopEndDate, setUserLoanStopEndDate] = useState('');
  const [UserLoanStopStartDate, setUserLoanStopStartDate] = useState('');
  const [UserReservationCnt, setUserReservationCnt] = useState('');
  const [UserOverdueCnt, setUserOverdueCnt] = useState('');
  const [UserMutualLoanCnt, setUserMutualLoanCnt] = useState('');
  const [Comment, setComment] = useState('');
  const [HopeBookCount, setHopeBookCount] = useState('');
  const [UserNo, setUserNo] = useState('');
  const [Timer, setTimer] = useState(0);
  const [Open, setOpen] = useState(false);
  const [OpenCategory, setOpenCategory] = useState(false);
  const [Sort, setSort] = useState('')
  const {search} = useLocation();
  const [BookInfo, setBookInfo] = useState([])
  const [TitleTemp, setTitleTemp] = useState('')
  const [isValid, setIsValid] = useState(true)
  const [CollapsingSetting, setCollapsingSetting] = useState(true)
  const {id} = queryString.parse(search);

   // ref를 위한 변수 선언 
   const inputRef = useRef();



  const onClose = () => {
    setOpen(false);
  };

  const onCategoryClose = () => {
    setOpenCategory(false);
  };

  const showCategory = async(sort) => {
    
    switch (sort) {
      case 'age': setSort('연령별 인기');
        
        break;
      case 'month': setSort('이달의 인기');
        
        break;
      case 'new' : setSort('신착');
        
        break;
      default:
        break;
    }

    const result = await getBookInfo(libraryManageCode, sort);

    console.log('result' , result);

    if(result.data.code==='Y') {
      setBookInfo(result.data.data.contents.bookList) 
    }
    // setOpenCategory(true);
  };

  const DescriptionItem = ({ title, content }) => (
    <div className="site-description-item-profile-wrapper">
      {title}    :    {content}
    </div>
  );


  let nowZoom = 100;

  function zooms(){
    document.body.style.zoom = nowZoom + '%';
  
    if(nowZoom === 70){
      alert ("더 이상 축소할 수 없습니다.");                       //화면 축소율이 70% 이하일 경우 경고창
    }
  
    if(nowZoom === 200){
      alert ("더 이상 확대할 수 없습니다.");                       //화면 확대율이 200% 이상일 경우 경고창
    }
  }
  const collapseBookCloseYN = () => {
    if(CollapsingSetting) {
      message.warn('원활한 대화를 위해 책 리스트가 닫힙니다.');  
      setIsValid(false);
      setCollapsingSetting(false)
     } 
    }
  const zoomOut = () => {
   
    nowZoom = nowZoom - 10;

    if(nowZoom <= 70) nowZoom = 70;            //화면크기 최대 축소율 70% 
    zooms();
  }
  const inputReact = () => {
  
    return (
      <input   
      ref = {inputRef}
      value={Text}
      size="large"
      className='message-input'
      placeholder="여기에 질문해주세요."
      onClick={collapseBookCloseYN}
      onChange={inputMessage} onKeyDown={keyPressHandler} />
    );
  
  }
  
  libraryList.forEach(element => {
    if(element.value === id) {
      libraryManageCode = element.value 
      library = element.label
    }
  })

  const bottomRef = useRef([]);
  const topRef = useRef([]);
  const dispatch = useDispatch();
  const [Text, setText] = useState('');
  const [Id, setId] = useState('');
  const [Pw, setPw] = useState('');
  const [LibName, setLibName] = useState('')

  const messagesFromRedux = useSelector(state => state)
  const navigate = useNavigate();

  async function userTokenCheck () {

    const headers = {
      'x-access-token': sessionStorage.getItem('userToken'),
      'Content-Type': 'application/json',
    }
  
    const config = {headers}
    
    const response = await axios.post('/v1/bot/kolas/tokenCheck', {}, config);

    if(response['data'].data.code === 'N') {
      sessionStorage.removeItem('userToken');
      setAvatarSetting(false);
    } else {
      setAvatarSetting(true);
    }
    return null;
  }

  const getSession = async() => {
    const result = await axios.get(`/v1/bot/initSession`);
    sessionStorage.setItem('sessionId',  result.data.sessionId);
	}

  const getBooFunc = async(manageCode, sort) => {
     
    switch (sort) {
      case 'age': setSort('연령별 인기');
        
        break;
      case 'month': setSort('이달의 인기');
        
        break;
      case 'new' : setSort('신착');
        
        break;
      default: setSort('이달의 인기');
        break;
    }
    const result = await getBookInfo(manageCode, sort);

    if(result.data.code==='Y') {
      setBookInfo(result.data.data.contents.bookList) 
    }
  }

  useEffect(() => {
 
    getBooFunc(libraryManageCode, 'month');

    // const { ipcRenderer } = window.require('electron');
    // const message = '한국'

    // ipcRenderer.send('promiseFlag',message);            //promiseFlag 앞에 값(promiseFlag) 을 수신하는 곳과 동일하게 해야한다.

    // ipcRenderer.on('answer', (event, argument) => {
    //   alert(argument);
    // })
    // textQuery('너를 소개해줘');

    if(!sessionStorage.getItem('sessionId')) {getSession();}
   
    if(Expire===0) {
      logoutHandler();
    }

    if(sessionStorage.getItem('userToken')) {
      userTokenCheck();
    }
    // 👇️ 메시지 변화가 있을 때마다 스크롤 다운
    bottomRef.current?.scrollIntoView({behavior:"smooth"});


 
    
  }, [Expire, messagesFromRedux]);

  const reloadPage = async() => {

    const sessionId = sessionStorage.getItem('sessionId');

    const headers = {
      'session-id': sessionId,
      'Content-Type': 'application/json',
    }
  
    const config = {
      headers
    }

    await axios.get('/v1/bot/context', config);

    return await dispatch(saveMessage({delete: true})); 
  }

  const collapseBook = () => {
    if(CollapsingSetting) {
      setIsValid(false);
      setCollapsingSetting(false)
    } else {
      setIsValid(true);
      setCollapsingSetting(true)
      }
    }

  const back = () => {
    reloadPage();
    logoutHandler();
    navigate(`/chatbot/index?id=${id}`);
  }

  const inputMessage = async(event) => {
    const text = event.currentTarget.value;
    setText(text);
  }

  const textQuery = async(text) => {

    try {


      setText('');

      let vObj = '';
      let conversation = ''
      
      conversation = {
        who:'user',
        content:{
          text: {
            text:text
          }
        }
      }

    await dispatch(saveMessage(conversation));

    const headers = {
      'session-id': sessionStorage.getItem('sessionId'),
      'x-access-token': sessionStorage.getItem('userToken'),
      'Content-Type': 'application/json',
    }

    const config = {headers}

    const formData = {
      'msg' : text,
      'libName' : library,
      'manageCode' : libraryManageCode,
      'id' : window.localStorage.getItem('id')
    }
    
    const response  = await axios.post('/v1/bot/message', formData, config);

    // console.log('response', response);

    if(response.data.code === 'N') {
      return message.info('Error happened in server');
    }

    setSpinning(false);
    
    const main                  = response.data.data.mainIntent;
    const subIntentList         = response.data.data.subIntentList;
    const finishValuation       = response.data.data.finishValuation;
    const intentEng             = main.intentName;
    const displaySort           = main.displaySort;
    const intentName            = main.intentName;
    const agentResponse         = main.agentResponse;
    const ChoiceHopebookLibrary = main.ChoiceHopebookLibrary;
    const choiceLibrary         = main.choiceLibrary;
    const type                  = main.type;

    let intentSubInfo           = '';
    let intentSubInfoReplaced   = '';

    if(subIntentList) {
      intentSubInfo = subIntentList.intentSubInfo
      intentSubInfoReplaced = subIntentList.intentSubInfoReplaced
    }
    
    switch (displaySort) {

        case 'login' : 

          vObj = {
            DfMsg : main.dfMsg,
            WelcomeStart:'N'
            }

          const libName  =  main.libName;

          setLibName(libName)
          setIntentName(intentName)
          setAgentResponse(agentResponse)
          setLoginPopup(true);
          
          break;

          /**희망도서신청을 위한 도서관 선택 */
        case 'hopeBookLib' : 

          vObj = {
            DfMsg: main.dfMsg,
            ChoiceHopebookLibrary: ChoiceHopebookLibrary,
            WelcomeStart: 'N'
            }
        break;

        /** 도서관 선택 */
        case 'lib' :
            
          vObj = {
              DfMsg : main.dfMsg,
              ChoiceLibrary: choiceLibrary,
              WelcomeStart:'N'
              }
        break;

        /** 슬라이드 형 */
        case 's1':
        if(main.intentApiInfo.applyList) {
          await dispatch(saveApplyList({totalCount : main.intentApiInfo.totalCount, applyList :main.intentApiInfo.applyList}))
        }
    
        // 로그인 부분에도 추가함!
        if(main.intentApiInfo.hopeApplyCancelList) {
          await dispatch(saveApplyCancelList( { libName : main.libName, intentEng, finishValuation : finishValuation, applyCancelList :main.intentApiInfo.hopeApplyCancelList}))
        }

        vObj = {
                  libName : main.libName,
                  finishValuation : finishValuation,
                  intentEng:intentEng,
                  bookReservationList : main.intentApiInfo.bookReservationList,
                  SubIntents: intentSubInfo,
                  ChoiceBook: main.intentApiInfo.choiceBook,
                  hopeApplyCancelList : main.intentApiInfo.hopeApplyCancelList,
                  ApplyList: main.intentApiInfo.applyList,
                  BookList: main.intentApiInfo.bookList,
                  Answer : main.intentApiInfo.chatbotMsg,
                  SearchKeyword : main.intentApiInfo.searchKeyword,
                  libCode: main.intentApiInfo.libCode,
                  bookReservationListForCancel: main.intentApiInfo.bookReservationListForCancel
                }
        break;

        /** 텍스트 형 */
        case 't1':
      
            if(main.intentApiInfo) {
              vObj = {
                libName : main.libName,
                intentEng,
                finishValuation : finishValuation,
                Answer : main.intentApiInfo.chatbotMsg, }
            }

            if(main.intentServiceInfo) {
              vObj = {
                libName : main.libName,
                intentEng,
                finishValuation : finishValuation,
                Title: main.intentServiceInfo.intentKor,
                Answer : main.intentServiceInfo.chatbotMsg,
                SubIntents: intentSubInfo,
                SubIntents2: intentSubInfoReplaced,
                WebLink : main.intentServiceInfo.webLink,
                WelcomeStart:'N'
              }
            }
        break;
        /** 이어지는 인텐트가 있는 경우 */    
        case 'continue':
    
          vObj = {
            DfMsg : main.dfMsg,
            WelcomeStart:'N'
          }
        break;

        /** 예외 처리 */
        default:
          let dm = main.dfMsg;

          if(!dm) {
            dm ='현재 서비스 준비중이에요.'
          }

          vObj = {
            DfMsg: dm,
            type:type,
            SubIntents: intentSubInfo,
            SubIntents2: intentSubInfoReplaced,
            WelcomeStart:'N'
          }
          break;
      }

      conversation = {
        who:'bot',
        content:{
          text: {
            text : vObj
          }
        }
      }

      await dispatch(saveMessage(conversation));

    } catch (error) {
      message.info('알 수 없는 오류 발생');
     console.log(error);
    }
  }

  const sendMsgHandler = () => {
    if(!Text) {return message.info('우선 궁금하신 내용을 입력해주세요.');}
    textQuery(Text);
  }

  const idInputHandler = (event) => {
    const id = event.currentTarget.value;
    setId(id)
  }

  const pwInputHandler = (event) => {
    const pw = event.currentTarget.value;
    setPw(pw)
  }

  const loginRequestHandler = async() => {


    // kolas 로그인
    const headers = {
      'session-id': sessionStorage.getItem('sessionId'),
      'x-access-token': sessionStorage.getItem('userToken'),
      'Content-Type': 'application/json',
    }

    const config = {
      headers
    }

    /** session생성하여 보내기 pw암호화 해놓기! */
    const formData = {
      userId : Id,
      userPw : Pw,
      system : 'chatbot',
      intentName : IntentName,
      libName : LibName,
      agentResponse: AgentResponse
    }

    const result = await dispatch(chatbotLogin(formData, config));

    const data =  result.payload.data.data;

    if(!data.result) {
     return message.info(data.message);
    } else {

      setLoginPopup(false);
      setIntentName('');

      //userToken 유효한지 체크
      const userToken = data.contents.userToken;
      const expiresIn = data.contents.expiresIn;
      // 분 기준의 값으로 체크한다.
      // 60m으로 들어오면 60값만 참고
      const numCount = Number(expiresIn.substring(0,expiresIn.length-1));
      const formData = {time:numCount}
      const resultTime = await dispatch(saveTime(formData));

      if(userToken) {
  
        if(data.msg) {

          if(data.hopeApplyCancelList) {
            await dispatch(saveApplyCancelList( {applyCancelList :data.hopeApplyCancelList}))
          }
  
          const vObj = {
            DfMsg : data.msg,
            hopeApplyCancelList: data.hopeApplyCancelList,
            bookReservationList: data.bookReservationList,
            WelcomeStart:'N'
          }
    
          const conversation = {
            who:'bot',
            content:{
              text: {
                text : vObj
              }
            }
          }
          await dispatch(saveMessage(conversation));
        }
        
        sessionStorage.setItem('userToken', userToken)
  
        setAvatarSetting(true);
        setExpire( Date.now() + 1000 * 60 * Number(resultTime.payload.time) * 1 * 1);
        setUserInfo(true);
      }

      return message.success('로그인 성공');
    }
  }
  
  const keyPressHandler = (event) => {
  
    const text = event.currentTarget.value;
    
    if(event.key ==='Enter') {
      if(!text) {
        return message.info('우선 궁금하신 내용을 입력해주세요.');
      }



      textQuery(text);
      showLoader();
    }
  }
 
  const botMessageHandler = (val) => {
    if(CollapsingSetting) {
      message.warn('원활한 대화를 위해 책 리스트가 닫힙니다.');  
      setIsValid(false);
      setCollapsingSetting(false)
     } 
    showLoader();
    textQuery(val);
  }

  const loginPopupHandler = () => {
    setLoginPopup(true);
  }

  const logInfo = async() => {

    const headers = {
      'x-access-token': sessionStorage.getItem('userToken'),
      'Content-Type': 'application/json'
    }
  
    const config = {headers}
    
    const response = await axios.post('/v1/bot/tokenCheck', {}, config);

    if(response['data'].code === 'N') {
      sessionStorage.removeItem('userToken');
      setAvatarSetting(false);
      message.warn('로그아웃 되었습니다. 다시 로그인 해주세요.');
    } else {

      setOpen(true);

      const userInfo = response.data.userInfo;
      const barcode = response.data.barcode;
      const {libName, userName, memberClassDesc, userId, loanCount, overdueCount, reservationCount, comment, userNo , hopeBookCount} = userInfo

      setBarcodeFrame(barcode)
      setUserLibName(libName)
      setUserName(userName);
      setUserLoanCnt(loanCount);
      setUserOverdueCnt(overdueCount);
      setComment(comment);
      setUserMemberClassDesc(memberClassDesc);
      setHopeBookCount(hopeBookCount);
      setUserReservationCnt(reservationCount)
      setUserNo(userNo)
      setAvatarSetting(true);
    }
    return null;
  }

  const logoutHandler = () => {

    const userToken = sessionStorage.getItem('userToken');

    if(!userToken) return;

    setLoginPopup(false);
    setAvatarSetting(false);
    setExpire(0);
    message.info('로그아웃 하였습니다.');

    sessionStorage.removeItem('userToken');
  }
  
 const CountdownHandler = (val) => {

  if (val && 58.97 * 1000 < val && val < 59 * 1000) {
      notification.open({
        message: <div>알림 <AlertTwoTone /></div>,
        description:
        <div> '로그아웃 시간이 얼마 남지 않았어요!'</div>,
        duration: 0,
      })
  }
 }

 const getStatistics = async() => {

  setModalOpen(true)

  const headers = {
    'x-access-token': sessionStorage.getItem('userToken'),
    'Content-Type': 'application/json'
  };

  const config = {
    headers
  };

  const formData = {
    serviceName : 'getStatistic',
    bodyParam: {
      libName : library
    }
  };

  const response = await axios.post('/v1/bot/chatbotDBService', formData, config);

  const responseData = response.data.data;

  if(responseData.code ==='Y' && responseData.intentServiceLog.length >= 1 ) {
    
    const intentServiceLog = responseData.intentServiceLog
    
    const intentCol = intentServiceLog.filter((elem,i) => {

        if(elem.keyword && i !== 5 && elem.intent !== 'Default Fallback Intent' ) {
          return elem
        }
      
    })

    setModalTitle(`${library}도서관에서 많이 묻는 질문`);

    if(intentCol[0].lib_name){
      setModalText(	
        <div>
          <List
            itemLayout="horizontal"
            dataSource={intentCol}
            renderItem={(item,i) => (
              <List.Item>
              <List.Item.Meta
                avatar={<div>{i+1}위</div>}
                title={<div style={{  cursor: 'pointer'}} onClick={() => {textQuery(item.keyword); setModalOpen(false);} }> {item.keyword} ({item.lib_name}도서관 - {item.intentcount}번)</div>}
              />
              </List.Item>	
              )}
              />
          </div>
          )
      } else {
        setModalText(	
          <div>
            <List
              itemLayout="horizontal"
              dataSource={intentCol}
              renderItem={(item,i) => (
                <List.Item>
                <List.Item.Meta
                  avatar={<div>{i+1}위</div>}
                  title={<div style={{  cursor: 'pointer'}} onClick={() => {textQuery(item.keyword); setModalOpen(false)}}> {item.keyword} ({item.intentcount}번)</div>}
                />
                </List.Item>	
          
                )}
                />
            </div>
            )
      }
  } else {
    setModalTitle('데이터가 없습니다.');
  }

 }

  const onFinish = async() => {
    setExpire(0);
    return await dispatch(saveTime(''));
  };
  
  const top = (    
  <div className="top">
  <span className="hole">
    <i></i><i></i><i></i>
  </span>
  <span className="btns">
    <button onClick={()=>{message.info('북씨 챗봇에 대해 무엇이든 물어보세요!')}} className="btn-q">?</button>
    {/* <button className="btn-x"><Link to="/chatbot/index"><i>닫기</i></Link></button> */}
    <button onClick={()=>{back();}} className="btn-x"><i>닫기</i></button>
  </span>
  </div>)
  
  const login = (
  <div className="login-box">
    <div className='form-replace'>
      <button className="btn-close" onClick={()=>{setLoginPopup(false);}}></button>
      <input type="text" id="username" name="username" onChange={idInputHandler}  placeholder="아이디"/><br/>
      <input type="password" id="password" name="password" onChange={pwInputHandler}  placeholder="비밀번호"/><br/><br/>
      <input type="button" onClick={loginRequestHandler} value="로그인"/>
    </div>
  </div>
  )

  const [ModalTitle, setModalTitle] = useState('');
	const [ModalOpen, setModalOpen] = useState(false)
  const [modalText, setModalText] = useState('');
  const [options, setOptions] = useState([]);

  const closeModal = () => {
		setModalOpen(false);
	  };

  const onSearch = async(searchText) => {

    if(!searchText) {
      return setOptions([])
    }

    const headers = {
      'session-id': sessionStorage.getItem('sessionId'),
      'x-access-token': sessionStorage.getItem('userToken'),
      'Content-Type': 'application/json',
    }

    const config = {
      headers
    }

    const formData = {
      'word' : searchText,
    }


      const response    = await axios.post('/v1/bot/wordSearch', formData, config);

      if(response.data.length >= 1) {
        let reInput =[]
        for(const elem of response.data) {
          reInput.push({value:elem});
        }
        setOptions(reInput);
      }



   
  };

  const showLoader = () => {
    setSpinning(true);
  };


  const onSelect = (data) => {
    textQuery(data);
    setOptions([])
  };

  const items = [
    {
      key: '1',
      label: (
        <a target="_blank" rel="noopener noreferrer" href="">
         준비중이에요.
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a target="_blank" rel="noopener noreferrer" href="">
        준비중이에요.
        </a>
      ),
      icon: <SmileOutlined />,
      disabled: true,
    },
    {
      key: '3',
      label: (
        <a target="_blank" rel="noopener noreferrer" href="">
          준비중이에요.
        </a>
      ),
      disabled: true,
    },
    {
      key: '4',
      danger: true,
      label: '준비중이에요.',
    },
  ];


  const getBookInfo = async(manageCode, sort) => {
     try {
  
    const response = await axios.get(`/v1/bot/getbookinfo?manageCode=${manageCode}&sort=${sort}`);
  
  return response;
     } catch (error) {
      console.log(error);
      
     }
  }

	let settings = {
    dots: false,
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 1500,
    cssEase: "linear",
	  responsive: [
		{
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			dots: true
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			initialSlide: 2,
			infinite: false,
			dots: false
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: false,
			dots: false
		  }
		}
	  ]
	};


  const gridStyle = {
    width: '100%',
    textAlign: 'center',
  };

  const genExtra = () => {if(isValid) {return (
    <div className='chat-box-head'>
      <div className='wrap-vertical'>
        <Button style={{
              paddingTop: '0px',
              paddingBottom: '0px',
              paddingRight: '5px',
              paddingLeft: '5px'
        }} type="default" shape="round" onClick={(e)=> {showCategory('new'); e.stopPropagation();}}><NotificationOutlined style={{ fontSize: '16px', color: '#08c' }} />신착</Button>
        <Button style={{
              paddingTop: '0px',
              paddingBottom: '0px',
              paddingRight: '5px',
              paddingLeft: '5px'
        }} type="default" shape="round" onClick={(e)=> {showCategory('month'); e.stopPropagation();}}><FireOutlined style={{ fontSize: '16px', color: 'red' }} />이달의 인기</Button>
        <Button style={{
              paddingTop: '0px',
              paddingBottom: '0px',
              paddingRight: '5px',
              paddingLeft: '5px'
        }} type="default" shape="round" onClick={(e)=> {showCategory('age'); e.stopPropagation();}}><ThunderboltOutlined style={{ fontSize: '16px', color: 'gold' }}/>연령별 인기</Button>
        {/* <Button type="default" shape="round" onClick={(e)=>{ showCategory('GPT 추천도서'); e.stopPropagation();}}><LoadingOutlined />GPT 추천도서</Button> */}
      </div>
</div>
  )} else {
    return null;
  }}

  const onChangeCollapse = (key) => {
    if(key.length < 1) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }
  return (
        <div>
              <Spin spinning={spinning} style={{
                    top: '400px'
              }} size="large" tip="답변 내용 생성중...">
          {/* <Spin tip="Loading">
            <div className="content" />
          </Spin> */}

	
    <Modal
        title= {ModalTitle}
		description="1"
        open={ModalOpen}
		footer={null}
		centered={true}
		closable={true}
		onCancel={closeModal}
		>
		{modalText}
		</Modal>

          {
          LoginPopup
          ? 
          login 
          :
          null
          }
          <div className='chatbot'>
          
            <div className="chat-tlt">


        
            {/* <Badge.Ribbon style={{ float: 'right' }}  text="챗 지피티 플러스" color="pink">    */}


            <div class='div-heads'>
            <h2 style={{paddingLeft: '11px'}}>
            {/* <img  style={{ 
                              // backgroundColor: '#fdf5e6',
                              height:'20%',
                              width:'20%',
                              objectFit: 'scale-down'
                            }} 
                            src='https://www.jungnanglib.seoul.kr/include/image/common/logo.png' /> */}

                            {
                              library==='통합' ? 
                              `챗봇 중랑구립도서관`
                              :
                              `중랑구립도서관(${library})`

                            }
            </h2>
            {/* <h2>    
              <Dropdown
              menu={{
                items,
              }}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                <SettingOutlined />
                </Space>
              </a>
            </Dropdown> 
           </h2>
            */}
           <h2>
            
                <Tooltip  color={'#E4B660'} title={`책 목록`}> 
                  <BookOutlined onClick={collapseBook} style={{ color:'#E4B660', cursor:'pointer', marginRight: '5px', fontSize: 'medium'}} />
                </Tooltip>

                |
                <Tooltip  color={'#F2AB39'} title={`자주묻는 질문`}> 
                  <BarChartOutlined onClick={getStatistics} style={{ cursor:'pointer', color:'#F2AB39', marginLeft: '7px', marginRight: '5px', fontSize: 'medium'}} />
                </Tooltip>

                |
                <Tooltip  color={'#69491A'} title={`새로 고침`}> 
                  <SyncOutlined onClick={reloadPage}  style={{   cursor:'point', color:'#69491A', marginRight: '10px',  marginLeft: '7px', fontSize: 'medium'}} spin />
                </Tooltip>
                {/* <Tooltip placement="right" color='gold' title={
                  <div>
                    <button onClick={reloadPage}>새로고침 <SyncOutlined spin /> </button>
                    <br/>
                    <button onClick={collapseBook}>신착 및 추천도서 {CollapsingSetting ? '닫기' : '열기'} <BookOutlined /> </button>
                    <br/>
                    <button onClick={getStatistics}>사용자 질문 순위 <BarChartOutlined style={{ cursor:'point', color:'gold', marginLeft: '1px', fontSize: 'larger'}}/></button>
              
                  </div>
                   }>
                  <UnorderedListOutlined  style={{  color:'white', cursor:'point', color:'gold', marginRight: '10px', fontSize: 'xx-larger'}}/>
                </Tooltip> */}
              
           
            </h2>
           </div>
           
        {/* </Badge.Ribbon>  */}
      
   
              </div>


              {
              AvatarSetting ? 
                  <Countdown className="expire-time" value={Expire} onChange={CountdownHandler} onFinish={onFinish}/>
              :
              null
              }

              {

                CollapsingSetting ?

                <Collapse collapsible="icon" onChange={onChangeCollapse} defaultActiveKey={['1']} ghost>
                    <Panel header={genExtra()} key="1">

                    {/* <div className='chat-box-head'>

                      <Button type="default" shape="round" onClick={()=> showCategory('GPT 추천도서')}><LoadingOutlined />GPT 추천도서</Button>
                      <Button type="default" shape="round" onClick={()=> showCategory('신작도서')}><NotificationOutlined /> 신작</Button>
                      <Button type="default" shape="round" onClick={()=> showCategory('인기도서')}><FireOutlined />인기</Button>
                      
                    </div> */}

                    <div className="slider-container" style={{ 
                                      height:'250px',
                                      width:'100%',
                                      objectFit: 'contain'
                                    }}>

                    <Slider {...settings}>
                          {
                            BookInfo.map((elem,i)=> {
                              try {
                                return ( 
                                  <div key={i}>
                                    <Card key={i} type='inner'    
                                    style={{ width: '157px', marginLeft: '7px' }} hoverable 
                                    cover={
                                      <Badge.Ribbon text={Sort}>
                                        <Tooltip  color={'#87d068'} title={`${elem.title}  [${elem.loanStatus}]`}> 
                                      <img text-overflow='ellipsis' alt={elem.title}  
                                              style={{ 
                                                backgroundColor: '#fdf5e6',
                                                height:'260px',
                                                width:'100%',
                                                objectFit: 'fill'
                                              }}
                                              src={elem.coverUrl} />
                                              </Tooltip >
                                    </Badge.Ribbon>
                                              } 
                                              />
                                  </div>
                                      )
                                
                              } catch (e) {
                                if (e.message) {
                                  console.log('e.message', e.message);
                                  return false;
                                }
                              }
                              
                              })
                      
                        }
                      
                        </Slider>
                        </div>

                        </Panel>
    </Collapse>

                :
                null

              }

      {/* <Drawer title={TitleTemp} height={800} closable={true} placement="top" onClose={onCategoryClose} open={OpenCategory}>

      <Row gutter={[40, 24]}>
        {
          BookInfo.map(elem=> {


           return( 
          <Col span={6} >
            <Card
             style={{ width: '50%' }}
              cover={<img alt={elem.title} src={elem.coverUrl} />}
              actions={[
                <PushpinOutlined onClick={()=>{return message.info('내서재담기')}} key="pin" />,
                <EditOutlined onClick={()=>{return message.info('독후감 보기')}} key="edit" />,
                <EllipsisOutlined onClick={()=>{return message.info('자세히 보기')}} key="ellipsis" />,
              ]}
              >
                <Meta title= {elem.title}   style={{ height: '100%' }} description={elem.description}/>
              </Card>
            </Col>  )
    
          })
        }
        </Row>
      </Drawer> */}
   
            
            <div className='chat-box' style={{height: isValid ? null : '92%'}}>
                <div className='chat-cont' >
                  <div ref={topRef} />
                      <div className="chat-log">
                        <BotMessage 
                                handleFilters={botMessageHandler} 
                                params={{
                                  DfMsg: `안녕하세요. 
                                  중랑도서관 (${library}) 챗봇입니다. 
                                  무엇을 도와드릴까요?`,
                                  WelcomeStart:'Y'
                                  }} />
                          </div>
                              {
                              // eslint-disable-next-line array-callback-return
                              messagesFromRedux.chatbot.messages.map((message,index) => {
                                if(message.who==='bot') {
                                    return <BotMessage key={index} handleFilters={botMessageHandler} params={message.content.text.text} />
                                  }
                                  if(message.who==='user') {
                                    return <UserMessage key={index} params={{Text:message.content.text.text}} />
                                  }
                                }) 
                              }

                                                      

                      <div ref={bottomRef} />
                  </div>    
              </div>
          
                <div className='chat-message' id='mymsg' method='POST'>
                  <span>

                  {/* <AutoComplete
                      options={options}
                      onSelect={onSelect}
                      onSearch={onSearch}
                      style={{
                        width: 'calc(100% - 45px)',
                        paddingLeft: '10px',
                        input:'hover {background-color:red}'
                      }}
                      placeholder="바로 입력해주세요."
                      value={Text}
                      >   */}
                      {inputReact()}
                    {/* </AutoComplete> */}

                       {
                        AvatarSetting
                        ?
                        <Popconfirm
                        title="이용자"
                        description="이용자 관리"
                        okText="이용자정보"
                        cancelText="로그아웃"
                        onCancel={logoutHandler}
                        onConfirm={logInfo}
                        onOpenChange={() => {}}
                        icon={
                          <QuestionCircleOutlined
                            style={{
                              color: 'red',
                            }}
                          />
                        }
                        >
                        <button className='logInfo-btn' ></button>        
                        </Popconfirm>
                        :
                        <Tooltip placement="top" color='#6478aa' title={<span>로그인</span>}>
                          <button className='login-btn'  onClick={loginPopupHandler}></button>
                        </Tooltip>
                        }
                      <button onClick={sendMsgHandler}><i>입력</i></button>
                  </span>
                </div>
            </div>


              <Drawer
                  height='400px'
                  title= "이용자 프로필"
                  placement="top"
                  closable={true}
                  onClose={onClose}
                  open={Open}
                  getContainer={false}
                 
                >

                   {
                    UserNo ?
                    <Barcode displayValue={false} width={3} lineColor={'black'} fontSize={0.1} value={UserNo}/>
                    : <div style={{backgroundColor:'yellow'}}>'바코드 생성은 도서관 정회원만 가능합니다.'</div>
                  }
                  <br/>
                  <DescriptionItem title="- 이름" content={UserName+`(${UserNo})`} /><br/>
                  <DescriptionItem title="- 회원등급" content={UserMemberClassDesc+`(${Comment})`} />
                  <br/>
                  <DescriptionItem title="- 대출권수" content={UserLoanCnt} />

                  <DescriptionItem title="- 희망도서신청권수" content={HopeBookCount} />
              
                  <DescriptionItem title="- 도서예약권수" content={UserReservationCnt} />


                </Drawer>
                </Spin>
        </div>
  )
}